import { render } from "./Molde-Fechado.vue?vue&type=template&id=0facf9ae&scoped=true"
import script from "./Molde-Fechado.vue?vue&type=script&lang=js"
export * from "./Molde-Fechado.vue?vue&type=script&lang=js"

import "./Molde-Fechado.vue?vue&type=style&index=0&id=0facf9ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0facf9ae"]])

export default __exports__